import React from 'react';


const Footer = () => {
  return (
    <footer>
      <div className='footer'>
        <div className='footer__logo'>
          <div className='logo'>Gold</div><div className='logo'>Coast Koala</div>
        </div>
        <ul className='footer__menu'>
          <li><a href='/terms-of-service'>利用規約</a></li>
          <li><a href='/privacy-policy'>プライバシーポリシー</a></li>
          <li><a href='/'>お問い合わせ</a></li>
        </ul>
        <div className='footer__caption'>
          © Copyright Gold Coast Koala ll right reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;